import type { VirementQueryDTO } from '@/features/api/extranet/dto/Virement/VirementQueryDTO'
import { buildRechercheStore } from '../storeRechercheBuilder'
import type { VirementDTO } from '@/features/api/extranet/dto/Virement'

export const useRechercheVirementStore = buildRechercheStore<VirementQueryDTO, VirementDTO>({
  storeName: 'rechercheVirementStore',
  apiPath: '/virements',
})

